import styles from './BackgroundGradientBlur.module.scss'
import cx from 'classnames'

type BackgroundGradientBlur = {
  isFixedPosition?: boolean
  onClickHandler?: () => void
}

const BackgroundGradientBlur = ({ onClickHandler, isFixedPosition = false }: BackgroundGradientBlur) => {
  return (
    <div
      className={cx([styles['overlay'], isFixedPosition && styles['overlay--is-fixed']])}
      {...(onClickHandler && { onClick: onClickHandler })}
    />
  )
}

export default BackgroundGradientBlur
